package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.MysteryW500Rounded: ImageVector
    get() {
        if (_mysteryW500Rounded != null) {
            return _mysteryW500Rounded!!
        }
        _mysteryW500Rounded = Builder(name = "MysteryW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(439.95f, 721.91f)
                quadToRelative(116.77f, 0.0f, 199.37f, -82.04f)
                quadToRelative(82.59f, -82.04f, 82.59f, -199.82f)
                quadToRelative(0.0f, -116.77f, -82.54f, -199.37f)
                quadToRelative(-82.54f, -82.59f, -199.31f, -82.59f)
                quadToRelative(-117.78f, 0.0f, -199.88f, 82.54f)
                quadToRelative(-82.09f, 82.54f, -82.09f, 199.31f)
                quadToRelative(0.0f, 117.78f, 82.04f, 199.88f)
                quadToRelative(82.04f, 82.09f, 199.82f, 82.09f)
                close()
                moveTo(440.0f, 440.0f)
                close()
                moveTo(439.97f, 602.39f)
                quadToRelative(-72.45f, 0.0f, -134.31f, -38.26f)
                reflectiveQuadToRelative(-96.86f, -102.5f)
                quadToRelative(-5.71f, -10.2f, -5.59f, -21.63f)
                quadToRelative(0.12f, -11.43f, 5.83f, -21.63f)
                quadToRelative(35.0f, -64.24f, 96.78f, -102.5f)
                quadToRelative(61.77f, -38.26f, 134.1f, -38.26f)
                quadToRelative(72.32f, 0.0f, 133.68f, 38.64f)
                quadToRelative(61.36f, 38.64f, 96.36f, 102.12f)
                quadToRelative(5.71f, 10.2f, 5.83f, 21.63f)
                quadToRelative(0.12f, 11.43f, -5.59f, 21.63f)
                quadToRelative(-35.0f, 64.24f, -96.39f, 102.5f)
                quadToRelative(-61.38f, 38.26f, -133.84f, 38.26f)
                close()
                moveTo(440.11f, 537.61f)
                quadToRelative(53.93f, 0.0f, 99.1f, -25.85f)
                quadToRelative(45.16f, -25.85f, 71.16f, -71.69f)
                quadToRelative(-26.0f, -44.87f, -71.18f, -71.28f)
                quadToRelative(-45.17f, -26.4f, -99.19f, -26.4f)
                quadToRelative(-54.8f, 0.0f, -100.09f, 26.4f)
                quadToRelative(-45.28f, 26.41f, -71.28f, 71.28f)
                quadToRelative(26.0f, 45.84f, 71.28f, 71.69f)
                quadToRelative(45.29f, 25.85f, 100.2f, 25.85f)
                close()
                moveTo(440.0f, 502.39f)
                quadToRelative(26.0f, 0.0f, 44.19f, -17.84f)
                quadToRelative(18.2f, -17.83f, 18.2f, -44.55f)
                quadToRelative(0.0f, -26.0f, -18.2f, -44.19f)
                quadToRelative(-18.19f, -18.2f, -44.19f, -18.2f)
                quadToRelative(-26.72f, 0.0f, -44.55f, 18.2f)
                quadTo(377.61f, 414.0f, 377.61f, 440.0f)
                quadToRelative(0.0f, 26.72f, 17.84f, 44.55f)
                quadToRelative(17.83f, 17.84f, 44.55f, 17.84f)
                close()
                moveTo(440.0f, 808.13f)
                quadToRelative(-76.65f, 0.0f, -143.6f, -29.1f)
                quadToRelative(-66.94f, -29.1f, -116.64f, -78.79f)
                quadToRelative(-49.69f, -49.7f, -78.79f, -116.65f)
                quadToRelative(-29.1f, -66.96f, -29.1f, -143.62f)
                quadToRelative(0.0f, -75.64f, 29.1f, -142.7f)
                quadToRelative(29.1f, -67.05f, 78.79f, -117.13f)
                quadToRelative(49.7f, -50.07f, 116.65f, -79.17f)
                quadToRelative(66.96f, -29.1f, 143.62f, -29.1f)
                quadToRelative(75.64f, 0.0f, 142.65f, 29.11f)
                quadToRelative(67.0f, 29.12f, 117.13f, 79.18f)
                quadToRelative(50.12f, 50.06f, 79.22f, 117.09f)
                quadToRelative(29.1f, 67.02f, 29.1f, 142.75f)
                quadToRelative(0.0f, 65.02f, -21.13f, 122.93f)
                quadToRelative(-21.12f, 57.91f, -58.35f, 105.66f)
                lineToRelative(129.09f, 129.08f)
                quadToRelative(12.96f, 12.96f, 12.69f, 30.16f)
                quadToRelative(-0.26f, 17.19f, -13.21f, 30.15f)
                quadToRelative(-12.98f, 12.19f, -30.29f, 12.19f)
                quadToRelative(-17.3f, 0.0f, -30.26f, -12.19f)
                lineTo(667.35f, 729.65f)
                quadToRelative(-47.7f, 37.23f, -105.56f, 57.85f)
                quadToRelative(-57.85f, 20.63f, -121.79f, 20.63f)
                close()
            }
        }
        .build()
        return _mysteryW500Rounded!!
    }

private var _mysteryW500Rounded: ImageVector? = null
